import { Map } from 'immutable'

export const getReopenedTabPayments = (state, orderUuid) => {
  return state.VNTenders.getIn(['reopenedTabPayments', orderUuid], Map())
}
